import { sanitizeRuntimeHtml } from './sanitizeRuntimeHtml.js';
export const toSafeRuntimeHtml = (value) => ({
    __html: sanitizeRuntimeHtml(value),
});
